import RoundedImageWithFallback from "components/rounded-image-with-fallback";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AmplitudePageName, track } from "utils/amplitude";
import { apiHostAndPath } from "utils/api";
import getClasses from "utils/getClasses";
import styles from "./AuthorFullBio.module.scss";

interface AuthorFullBioProps {
  blog: Blog;
  orchidPro: OrchidPro | undefined;
  amplitudePageName: AmplitudePageName;
}

const AuthorFullBio = ({
  blog,
  orchidPro,
  amplitudePageName,
}: AuthorFullBioProps) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  return (
    <div
      className={
        !isPhonePortrait
          ? styles["author-full-bio"]
          : styles["author-full-bio--phone"]
      }
    >
      <Link
        to={
          blog.author_display_cognito_sub
            ? `/professional-search/${blog.author_display_cognito_sub}`
            : "#"
        }
        onClick={() =>
          track(amplitudePageName, "author-link", "click", {
            eventProperties: {
              "blog-id": blog.id,
              "blog-title": blog.title,
            },
          })
        }
      >
        <Row className="mb-4 align-items-center">
          <RoundedImageWithFallback
            src={
              blog.author_display_cognito_sub
                ? apiHostAndPath(
                    `/api/users/orchid_pro/profile_image/${blog.author_display_cognito_sub}`,
                  )
                : apiHostAndPath(`/blog/profile_image/${blog.id}`)
            }
            width={!isPhonePortrait ? 72 : 40}
            height={!isPhonePortrait ? 72 : 40}
          />
          <span className={!isPhonePortrait ? "ml-4" : "ml-3"}>
            <h4
              className={getClasses(
                "deep-blue",
                !isPhonePortrait ? "rg-24 questrial" : "md-14",
              )}
            >
              {blog.author_display_name}
            </h4>
          </span>
        </Row>
      </Link>
      <p className="rg-14">
        {blog.author_display_description
          ? blog.author_display_description
          : orchidPro
          ? orchidPro.biography
          : ""}
      </p>
    </div>
  );
};

export default AuthorFullBio;
